import { Component } from '@angular/core';

@Component({
  selector: 'app-location-admin',
  templateUrl: './location-admin.component.html',
  standalone: false,
})
export class LocationAdminComponent {}
